import React, {  Component } from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';

class ConfirmUpdateManageUsersResposibilities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }

    handleCancel(event) {
		event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.resetResponsibilities();
    }

    handleContinue(event){
        browserHistory.push('/home');
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ConfirmUpdateManageUsersResposibilities', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="employeeAccount&PriceSourceDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <p><b>You are about to update the responsibilities of account.</b></p>
                    <p>Are you sure you want to update?</p>
                    <div className="noButtonContainer">
                        <a className="noButton blueButton" onClick={this.handleCancel.bind(this)}>Cancel</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.props.updateDetails.bind(this)}>Continue</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ConfirmUpdateManageUsersResposibilities = connect(mapStateToProps)(ConfirmUpdateManageUsersResposibilities);
export default ConfirmUpdateManageUsersResposibilities;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmUpdateManageUsersResposibilities.js